import CloseIcon from '@mui/icons-material/Close';
import { useStore } from '../components/state/zustand-store';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import type { SnackbarCloseReason } from '@mui/material/Snackbar';
export default function SharedSnackbar() {
  const { snackbar, setSnackbar, colorMode } = useStore();

  return (
    <Snackbar
      open={snackbar.open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      onClose={(
        _event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason
      ) => {
        if (reason === 'clickaway') {
          return;
        }

        setSnackbar({ ...snackbar, open: false });
      }}
      slots={{ transition: Slide }}
      autoHideDuration={snackbar.action ? null : 6000}
    >
      <Alert
        onClose={() => {
          setSnackbar({ ...snackbar, open: false });
        }}
        severity={snackbar.severity}
        sx={{
          width: '100%',
          bgcolor: colorMode === 'dark' ? 'background.paper' : '',
        }}
        action={
          snackbar.action ? (
            <>
              <Button
                variant="contained"
                size="small"
                onClick={snackbar.action.onClick}
              >
                {snackbar.action.label}
              </Button>
              <IconButton
                size="small"
                color="inherit"
                onClick={() => setSnackbar({ ...snackbar, open: false })}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          ) : undefined
        }
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
